import { Editor } from "@monaco-editor/react";
import { TextField, MenuItem, Button, FormControl, FormLabel, Switch, FormControlLabel } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";

const FloorplanAnalysisForm = () => {
  const [floorplanAnalysisFormData, setFloorplanAnalysisFormData] = useState({
    image_path: "",
    output_json_schema: "",
    detection_model: "",
    scale_factor: "",
    include_furniture: false,
    output_format: "JSON",
  });

  const detectionModelOptions = ["Model A", "Model B", "Model C"];
  const outputFormatOptions = ["JSON", "CSV"];

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFloorplanAnalysisFormData({
      ...floorplanAnalysisFormData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(floorplanAnalysisFormData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Image Path</FormLabel>
            <TextField name="image_path" value={floorplanAnalysisFormData.image_path} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Output JSON Schema</FormLabel>
             <Editor
              height="150px"
              name="output_json_schema"
              value={floorplanAnalysisFormData.output_json_schema}
              onChange={handleChange}
            />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Detection Model</FormLabel>
            <TextField select name="detection_model" value={floorplanAnalysisFormData.detection_model} onChange={handleChange}>
              {detectionModelOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Scale Factor</FormLabel>
            <TextField type="number" name="scale_factor" value={floorplanAnalysisFormData.scale_factor} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControlLabel
            control={
              <Switch
                name="include_furniture"
                checked={floorplanAnalysisFormData.include_furniture}
                onChange={handleChange}
              />
            }
            label="Include Furniture"
          />
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Output Format</FormLabel>
            <TextField select name="output_format" value={floorplanAnalysisFormData.output_format} onChange={handleChange}>
              {outputFormatOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12} textAlign="center">
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default FloorplanAnalysisForm;
